<template>
    <div style="width: 1200px;  margin: 0 auto;">
        <Title :title="{name: '日志中心'}"></Title>
        <div >
            <el-card class="box-card">
                <el-row :gutter="20"  >
                    <el-col :span="10">
                        <el-date-picker
                                style="width:400px;margin-left:30px;"
                                v-model="condition.createTimeArr"
                                value-format="yyyy-MM-dd"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="6">
                        <el-button icon="el-icon-refresh-left" type="primary" @click="reset">重置</el-button>

                        <el-button icon="el-icon-search"   type="primary" @click="getAllSysLogTable">查询</el-button>
                    </el-col>
                </el-row>
            </el-card>
            <div style="margin: 10px auto; ">
                <el-card class="box-card" style="min-height: 650px;">
            <el-table
                    :data="sysLogTable"
                    :header-cell-style = "{background: 'rgb(245,245,245)', color: 'black'}"
                    :cell-style="{color: 'black'}"
            >
                <el-table-column
                        prop="userName"
                        label="操作人"
                        show-overflow-tooltip
                />
<!--                <el-table-column-->
<!--                        prop="requestIp"-->
<!--                        label="请求IP"-->
<!--                        show-overflow-tooltip-->
<!--                />-->
<!--                <el-table-column-->
<!--                        prop="requestUrl"-->
<!--                        label="请求地址"-->
<!--                        show-overflow-tooltip-->
<!--                />-->
<!--                <el-table-column-->
<!--                        prop="requestMethod"-->
<!--                        label="请求方式"-->
<!--                        show-overflow-tooltip-->
<!--                />-->
<!--                <el-table-column-->
<!--                        prop="requestParam"-->
<!--                        label="请求参数"-->
<!--                        show-overflow-tooltip-->
<!--                />-->
                <el-table-column
                        prop="requestDesc"
                        label="请求描述"
                        show-overflow-tooltip
                />
                <el-table-column
                        prop="responseCode"
                        label="响应状态"
                        width="100">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.requestCode == 200" type="success">成功</el-tag>
                        <el-tag v-else type="danger">失败</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="createTime"
                        label="请求时间"
                        show-overflow-tooltip
                />
            </el-table>
            <div  style="width: 30%;margin: 20px auto;">
                <el-pagination @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="condition.page"
                               :page-sizes="condition.pageSizes"
                               :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
                               :total="totalCount">
                </el-pagination>
            </div>

                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
    import {requestGetAllSysLog} from "../../../api";
    import Title from "../../Title"
    export default {
        data() {
            return {
                components: {Title},
                totalCount: 0, //  // 总条数，根据接口获取数据长度(注意：这里不能为空)
                pageSizes: [8, 10, 15, 20, 30], //   // 个数选择器（可修改）
                condition: {
                    createTimeArr: [],
                    current: 1,
                    size: 8,
                },
                sysLogTable:[]
            }
        },
        methods: {
            handleSizeChange(val) {
                this.condition.current = 1
                this.condition.size = val
                this.getAllSysLogTable()
            },
            handleCurrentChange(val) {
                this.condition.current = val
                this.getAllSysLogTable()
            },
            reset(){
                this.condition.createTimeArr=[];
                this.getAllSysLogTable();
            },
            async getAllSysLogTable(){
                this.condition.startTime = this.condition.createTimeArr[0];
                this.condition.endTime = this.condition.createTimeArr[1];
                const res = await requestGetAllSysLog(this.condition);
                if(res.code == 200){
//                      this.$message.error("获取日志失败")
                    this.sysLogTable = res.rows;
                    this.totalCount = res.total;
                }else{
                    this.$message.error("获取日志失败")
                }
            }
        },created() {
            this.getAllSysLogTable();
        }
    }
</script>

<style scoped>

</style>
